import axios from "axios"

// const BASE_URL = "https://backend.taih.ai/api/leads"
const URL = process.env.REACT_APP_API_URL
const BASE_URL = `${URL}/api/reports`
const axiosApi = axios.create({
    baseURL: BASE_URL
})

axiosApi.interceptors.request.use(req => {
    const token = JSON.parse(localStorage.getItem('token'));
    if (token) {
        req.headers.Authorization = token
    }
    return req
})

export const ReportApis = {
    listAll: async (offset, limit) => {
        return axiosApi.get(`${BASE_URL}?page=${offset}&limit=${limit}`)
    },
    create: async (data) => {
        return axiosApi.post(`${BASE_URL}`, data)
    },
    export: async (filter) => {
        return axiosApi.get(`${BASE_URL}/export/excel?filter=${filter}`, { responseType: 'blob' })
    }
}
